import { InlineError } from '@akyga/shared-ui/InlineError';

export default InlineError;
